import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberRangePicker',
  props: {
    value: { default: ":" }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null };





function parseValue(value: string | null) {
  if (!value) {
    return { from: null as string | null, to: null as string | null };
  }

  const fromMatch = value.match(/([0-9.]+):/);
  const toMatch = value.match(/.*:([0-9.]+)/);
  return {
    from: fromMatch ? fromMatch[1] : null,
    to: toMatch ? toMatch[1] : null,
  };
}

const parsed = parseValue(props.value);
const from = ref(parsed.from);
const to = ref(parsed.to);

watch(
  () => props.value,
  (newValue) => {
    const parsed = parseValue(newValue);
    from.value = parsed.from;
    to.value = parsed.to;
  }
);

function valueUpdated() {
  if (!from.value && !to.value) {
    return emit("input", null);
  }

  emit("input", `${from.value ? from.value : ""}:${to.value ? to.value : ""}`);
}

return { __sfc: true,props, emit, parseValue, parsed, from, to, valueUpdated }
}

})